import { Box } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { InitializationWrapper } from '@planning/components'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import _ from 'lodash'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useParams } from 'react-router'
import { ReleaseHeader } from '../../Components/molecules/ReleaseHeader'
import { NonNumericReleaseTable } from '../../Components/organisms/NonNumericReleases/NonNumericReleaseTable'

export const NonNumericReleasesPage = observer(() => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const { nnrOrderItemStore } = usePlanningStore()

  const { vesselVisitId } = useParams()

  const visitId = Number(vesselVisitId)

  useEffect(() => {
    if (visitId > 0) {
      nnrOrderItemStore.fetchByVisitId(visitId)
    } else {
      nnrOrderItemStore.fetchAll()
    }
  }, [visitId, nnrOrderItemStore])

  const title = t('non-numericReleases', 'Non-numeric releases')

  const releaseItems = computed(() => {
    const items = _(nnrOrderItemStore.elements).values().value()

    if (visitId > 0) {
      return items.filter(item => item.data.carrierVisitId === visitId)
    } else {
      return items
    }
  }).get()

  return (
    <InitializationWrapper isInitializing={!nnrOrderItemStore.hasBeenInitialized}>
      <Box
        sx={{
          minHeight: '100%',
          bgcolor: theme.palette.grey[100],
        }}
      >
        <ReleaseHeader title={title} createPath={`${PATHS.orders.nonNumericReleases.url}/new`} />

        <Box padding={theme.customSpacing.m}>
          <NonNumericReleaseTable items={releaseItems} />
        </Box>
      </Box>
    </InitializationWrapper>
  )
})
